import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './questions.css';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useSelector } from 'react-redux';
import useGetdata from '../../../Hooks/useGetData';

const Questions = ({source}) => {
    useGetdata();
    const [expanded, setExpanded] = useState(false);
    const data = useSelector((store) => store.data.HomeData)
    const [Steps,setSteps] = useState({})
    useEffect(()=>{
      data?.items?.forEach((ele)=>{
                if(ele.Section  == "FAQ"){
                    setSteps(ele.Content)
                }
            })
    },[data])
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }; 

    const accordionData = [
        {
            ques: 'What can the drone carry?',
            desc: 'Lorem ipsum dolor sit amet consectetur. Quis nunc mattis quis nunc tincidunt lectus massa sagittis. Enim egestas lectus lectus laoreet orci.',
        },
        {
            ques: 'Do you coordinate with local Air Traffic Control?',
            desc: 'Lorem ipsum dolor sit amet consectetur. Quis nunc mattis quis nunc tincidunt lectus massa sagittis. Enim egestas lectus lectus laoreet orci.',
        },
        {
            ques: 'What is the maximum distance the drone can fly?',
            desc: 'Lorem ipsum dolor sit amet consectetur. Quis nunc mattis quis nunc tincidunt lectus massa sagittis. Enim egestas lectus lectus laoreet orci.',
        },
        {
            ques: 'Will the drone function in wind and rain?',
            desc: 'Lorem ipsum dolor sit amet consectetur. Quis nunc mattis quis nunc tincidunt lectus massa sagittis. Enim egestas lectus lectus laoreet orci.',
        }
    ];

    const getIcon = (panel) => (expanded === panel ? <RemoveIcon /> : <AddIcon />);

    const bgColor = source === 'UTM' ? '#fff' : source === 'about' ? '#FAFAFA' : '';

    return (
        <div className="questions-page-wrapper" style={{ background: bgColor }}>
            <motion.h2
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="heading1 capitalize-first-letter"
                style={{ color: source === 'about' || source === 'UTM' ? '#000' : '#fff' }}
            >
                {Steps.Title}
            </motion.h2>
            <div className="d-flex justify-content-center align-items-center">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        alignItems: 'center',
                        width: {
                            xs: '95%',
                            sm: '50%'
                        },
                        '@media (max-width:480px)': {
                            width: '95%'
                        }
                    }}>
                    {Steps?.Steps?.map((item, index) => {
                        const panelId = `panel${index}`;
                        return (
                            <Accordion
                                key={panelId}
                                expanded={expanded === panelId}
                                onChange={handleChange(panelId)}
                                sx={{
                                    width: '100%',
                                    borderRadius: '18px',
                                    overflow: 'hidden',
                                    boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
                                    '& .MuiAccordionSummary-content': {
                                        marginBottom: expanded === panelId ? '8px' : 0,
                                    },
                                    '& .MuiAccordionSummary-root': {
                                        borderBottom: expanded === panelId ? '1px solid #ccc' : 'none',
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={getIcon(panelId)}
                                    aria-controls={`${panelId}-content`}
                                    id={`${panelId}-header`}
                                    sx={{
                                        '& .MuiAccordionSummary-expandIconWrapper': {
                                            background: '#181D27',
                                            borderRadius: '18px',
                                            color: '#fff',
                                            padding: '4px',
                                        },
                                    }}
                                >
                                    <Typography component="span">{item.Title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="custom-desc">{item.Description}</Typography>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                </Box>
            </div>
        </div>
    );
};

export default Questions;
